module.exports = __webpack_public_path__ + "img/安全扫描系统-bg.267fe963.jpg";